/**
 Author - Harkirat Saluja
 Git - https://bitbucket.org/salujaharkirat/
 **/


import React from "react";
import SafeLink from "components/commons/SafeLink";
import {
  Heading,
  PrimaryText
} from "components/Text";
import Head from "next/head";
import {colors} from "nxtconstants";


const VulnerabilityProgram = () => {
  return (
    <>
      <Head>
        <title>VulnerabilityProgram | Wealthy</title>
        <meta content="Wealthy Vulnerability Program" name="description" />
        <link href="https://i.wlycdn.com/wealthy-home-page/new-fav-icon.png" rel="icon" />
      </Head>
      <div>
        <Heading
          color={colors.black}
          fontSize="1.6em"
        >
          Vulnerability Disclosure Program
        </Heading>
        <PrimaryText fontSize="1em">
          We take the security of our systems seriously, and we value the security community. The disclosure of security vulnerabilities helps us ensure the security and privacy of our users.
        </PrimaryText>
        <br />
        <Heading
          color={colors.black}
          fontSize="1.2em"
        >
          Guidelines
        </Heading>
        <PrimaryText fontSize="1em">
          We require that all researchers:
        </PrimaryText>
        <ul>
          <li><PrimaryText fontSize="1em">Make every effort to avoid privacy violations, degradation of user experience, disruption to production systems, and destruction of data during security testing.</PrimaryText></li>
          <li><PrimaryText fontSize="1em">Perform research only within the scope set out below.</PrimaryText></li>
          <li><PrimaryText fontSize="1em">Use the identified communication channels to report vulnerability information to us.</PrimaryText></li>
          <li><PrimaryText fontSize="1em">Keep information about any vulnerabilities you’ve discovered confidential between yourself and Wealthy until we’ve had 180 days to resolve the issue.</PrimaryText></li>
        </ul>
        <br />
        <PrimaryText fontSize="1em">If you follow these guidelines when reporting an issue to us, we commit to:</PrimaryText>
        <ul>
          <li><PrimaryText fontSize="1em">Not pursue or support any legal action related to your research.</PrimaryText></li>
          <li><PrimaryText fontSize="1em">Work with you to understand and resolve the issue quickly (including an initial confirmation of your report within 72 hours of submission).</PrimaryText></li>
          <li><PrimaryText fontSize="1em">Recognize your contribution to our Security Researcher Hall of Fame, if you are the first to report the issue and we make a code or configuration change based on the issue.</PrimaryText></li>
        </ul>
        <br />
        <Heading
          color={colors.black}
          fontSize="1.2em"
        >
          Scope
        </Heading>
        <ul>
          <li>
            <PrimaryText fontSize="1em">
              <strong>Website: </strong>
              www.wealthy.in
            </PrimaryText>
          </li>
          {/* <li><strong><span fontSize="1em">Website:</span></strong><span fontSize="1em">&nbsp;www.wealthy.in</span></li> */}
          <li>
            <PrimaryText fontSize="1em">
              <strong>Android App:&nbsp;</strong>
              <SafeLink
                href="https://play.google.com/store/apps/details?id=in.wealthy.android.wealthy&hl=en_IN"
                rel="noreferrer nofollow noopener"
                target="_blank"
              >
                  https://play.google.com/store/apps/details?id=in.wealthy.android.wealthy&amp;hl=en_IN
              </SafeLink>
            </PrimaryText>
          </li>
          <li>
            <PrimaryText fontSize="1em">
              <strong>iOS App:&nbsp;</strong>
              <SafeLink
                href="https://apps.apple.com/in/app/wealthy-best-mutual-funds/id1222950243"
                rel="noreferrer nofollow noopener"
                target="_blank"
              >
              https://apps.apple.com/in/app/wealthy-best-mutual-funds/id1222950243
              </SafeLink>
            </PrimaryText>
          </li>
        </ul>
        <br />
        <Heading
          color={colors.black}
          fontSize="1.2em"
        >
          Out of scope
        </Heading>
        <PrimaryText fontSize="1em">Any services hosted by 3rd party providers and services are excluded from the scope.</PrimaryText>
        {/* <ul>
          <li><PrimaryText fontSize="1em">[Other 3rd Party Services]</PrimaryText></li>
        </ul> */}
        <PrimaryText fontSize="1em">In the interest of the safety of our users, staff, the Internet at large and you as a security researcher, the following test types are excluded from scope:</PrimaryText>
        <ul>
          <li><PrimaryText fontSize="1em">Findings from physical testing such as office access&nbsp;(e.g.&nbsp;open doors, tailgating).</PrimaryText></li>
          <li><PrimaryText fontSize="1em">Findings derived primarily from social engineering&nbsp;(e.g.&nbsp;phishing, vishing).</PrimaryText></li>
          <li><PrimaryText fontSize="1em">Findings from applications or systems not listed in the&nbsp;‘Scope’&nbsp;section.</PrimaryText></li>
          <li><PrimaryText fontSize="1em">UI and UX bugs and spelling mistakes.</PrimaryText></li>
          <li><PrimaryText fontSize="1em">Network-level Denial of Service (DoS/DDoS) vulnerabilities.</PrimaryText></li>
        </ul>
        <PrimaryText fontSize="1em">Things we do not want to receive:</PrimaryText>
        <ul>
          <li><PrimaryText fontSize="1em">Personally identifiable information&nbsp;(PII)</PrimaryText></li>
          <li><PrimaryText fontSize="1em">Credit cardholder data</PrimaryText></li>
        </ul>
        <br />
        <Heading
          color={colors.black}
          fontSize="1.2em"
        >
            How to report a security vulnerability?
        </Heading>
        <PrimaryText fontSize="1em">If you believe you’ve found a security vulnerability in one of our products or platforms please send it to us by emailing security@wealthy.in.&nbsp;</PrimaryText>
        <PrimaryText fontSize="1em"><br /></PrimaryText>
        <PrimaryText fontSize="1em">Please include the following details with your report:</PrimaryText>
        <ul>
          <li><PrimaryText fontSize="1em">Description of the location and potential impact of the vulnerability;</PrimaryText></li>
          <li><PrimaryText fontSize="1em">A detailed description of the steps required to reproduce the vulnerability&nbsp;(POC&nbsp;scripts, screenshots, and compressed screen captures are all helpful to us); and</PrimaryText></li>
          <li><PrimaryText fontSize="1em">Your name/handle and a link for recognition in our Hall of Fame.</PrimaryText></li>
        </ul>
        <PrimaryText fontSize="1em">If you’d like to encrypt the information, please use our PGP key.</PrimaryText>
        <PrimaryText fontSize="1em">
          -----BEGIN PGP PUBLIC KEY BLOCK-----
          <br />
          <br />
          xsFNBF4BzjkBEAC6tFSW3P88jhwJWGzxq9Z3BE1ABBXeEr1msLOarn1ZU8tA
          Nmb1zpWeTSHtZz+BMq3KfEciAFGKWTtJm6XHfst18pqc9MT6+ygZtW3le10V
          8UDCNbtT4UZT6N9MhFu7quR8GPh5/uE31llr7K+86jTyLu+Bd4T9nJ2rBPqX
          CwNvJTcytRGdY0avwgkIRUFo80Eyet6WTHjvyOYBVCKsc3uG4CnLhWmiHA11
          q3XyBYH14ksyE+9aD8JubzEFQ6ymNecSeayXzE3BEO5nim5iPUoFpIQSDU9S
          zTi7rPVmVFF1YcDNSEpsUd2hT7t3o+etanRUeuS3ildGlFKVjp0IkvKaJynh
          crNbU6AyzD4JdHtQTppfRZzM4FK9lXwbe8YlaV1WK5mmmD1DViqesxqo09E7
          48ViF7Re6Rg6ur69erwlT7jd4qt/BIJdTCFaf3zVd7lBDSKseO9w39ZU2BAI
          3nE9+OXf/qVWN4s39np3NuGIyZ8JQUwzquZi+wurGGR3ToxEkQ8tR6J1xlsR
          Q3WXrfdKkIAKgN1gHhUqNnqD0Ar/38DuLrdm877H4zVSwcTC7XljGBVjCIFa
          TYiEbX+vhzrlT/xfYWsMyED+FdGYEBodX3GZHNvlPFc/V+QfMV9xGXNTmPWe
          3THTQwACZfKNAVahxonvIoW/0lMYuVMWVsIysQARAQABzSRXZWFsdGh5SW5m
          b1NlYyA8c2VjdXJpdHlAd2VhbHRoeS5pbj7CwXUEEAEIAB8FAl4BzjkGCwkH
          CAMCBBUICgIDFgIBAhkBAhsDAh4BAAoJEIEHVZjvNuRGrj0P/1NCi7dhCO8a
          nRUpL9f2d6Iu9KcR7XrSVRlgD0I+dhYLWpEYqdbRDiqGC8LXcV93JAFSthIQ
          rKbPjMYw7YQsFNumHB6fOiMuLYqm0AlZSj+xu7Jsvn0RzydNPKyPM3RT4H6B
          4v2j523Gz/leHecrqRf9qlLllbiV++jpiQ3eQYsSKCw1bSScpKjT9jfZKAyM
          xwtYz6Au0GOSh0scgnk4OOattnKEfwDWzj04+AtfrHsBIYx3pfe+yIjnxRMg
          rgm8xZGQx8Cz3hnKt2d5M0zGhFKQ4YOZX998+53bsX55iJbelarAKE6hDmE9
          kMpCo0L5tI/Lg6cJBaPDswu7jVAV+7D5Y1OQKv9chmjd8RAHO/0DWpMpOHZ9
          j5aKfnYIFAes3ZjTWF4AlKWQM4sn+u4ksSkliDwFCTd8KQf43jkaRK9X6sQH
          zrJmicR8vUwt1pfMShe45mVaIMkBQmZ3krNUVZ0sjdbpTHTplryLzZTODDbL
          dAspQFzFWg5qGTn4MzcK8+hqPqIyzoYyo3M4BUyv4cbqIjPqBItpAgA/IYyH
          ygkgWYf6aGqGRx5MOYXM3wD1TW7+AE4N2FyN1+cYzwMyh6hzjzQyfwXdFEOM
          FfJalhzqvI8Minp/nEqcJbTonKbWLkgdw5PaJufdQoy6iKPMIo6bMxMnWNdG
          1F+fkfb8CqS3zsFNBF4BzjkBEACvMuHyW0iJ7/343X5DJL8tVcpTwf4gkpQv
          Rsb8MxCCj027Q1Xy7yGe1SDHECU+B7bEGt9fvRB5ylESW6EuhjmJ8lIK1SuW
          EemM9xJKyxo8IYeGNMCWIZhnLxgZxXTBWsA5/i3H2fnAdnzcDcjD1dUceTjS
          pSsPOONir67ZTHm15eUXsh1CIeRIGsT8hQmZvvxo2SufTxFy3RVa4tMz9z6G
          ++i/RG2wkiDWR03adDGa3scr3Rxi3/tEr7QcxsENFIE22py2ZxLlu0dDdjsL
          x8Gq6ajTQSQK0noziSv3/rUL5mU2GRfzw1Fhcj+ar5k9YBqlMA/AZ2cwvFU4
          qOrDJrkgDw7m7ty5P54byi1oyNEucjxk8CrWFNKeulANIm3PvM/6I4QGUt/v
          a4JgFUs5O7sxWFKYbQdYg9te3IWf8C/c2vQy5/WWaDAYc7498oXePWHa7Fjg
          jQ5ko4ZqB+b4z9O6X9Fd+aOf2WhWQRJ0YoZeHpoGCYW58OUG2mj8D+bJRF7L
          6UtArtjS3db2YE81UP2lz1CZqTIYO/IGG3uiBnJUcvKldZmcfjiCE/xelOsy
          uvaAfNQUaTecM3egwD5uy7ybBuiQerBM23ZzG0Nq+CBXGIsTp+myOtoE05Od
          X4ekvkqXTa70JQnm1IUTqsiXtZRkQ2V3BAOn/+UoZjr3uTLCvwARAQABwsFf
          BBgBCAAJBQJeAc45AhsMAAoJEIEHVZjvNuRGq2sP/jcO8rQ0Fdk6RV1e8+TB
          XU/mkgM8eZxWMb3CNs+xCNFAYHhg8B9AeHLBvXt/6O4UieH884kRSF/oonh3
          0ioDP9nvc8G+i1ky6cXPm3PEp/xhVTebpaO1UI9ZJpGpwrTsysXQjMSWrWGD
          sLmHAhip2Ih5MnGWua8jpUmOFEbpdEHKAhlaaWIkaKa168bmNMfl19yerhiv
          wMYHS6DxiArrFcNMpz4jQS0rye6evhBxfnKs8O7ondyXwhcn5nZZ2tiasQ0/
          S2Lfh1ilSX9oqksl0swhNwbpHx0xt5EyxFvATgGZo/N82kx+U8ykgygKfNzx
          MPLm4eq3EotdEnmif1ADPQvEkqOtyfw98vbK+R14FVeWN5RD9prsLun/TghT
          8iH+nl8ABcuYM9yLaNxQ4nvyA3tHpBQlssnVsABXLygalgmo3rJkxTFs9eQV
          B429KmW/gFxxbyBco/6MZaGbF7aIoLEw95hNcRUn/kpHXDxj1I7+NRXk9a/t
          7Ug9Oke9foxIHVok9FhHhxh2gN6zS8ZKfHC6ZDD4FTRu4SOPWf3q06PCUwEU
          rfjmGT0bq9Rtskntl7hJuamiJG/EG6sTO3rOuzvGui2SyEes20AAZqic3Ngu
          EDwmcAftqrf6Z7os66FoXj0DNPSShL37l1zXI098tWRSO72FUksCyJKMFVdg
          M1iY
          =dPpU
          <br />
          <br />
          -----END PGP PUBLIC KEY BLOCK-----
        </PrimaryText>
      </div>
    </>
  );
};

export default VulnerabilityProgram;


